import type { TextFieldPropValue } from 'components/FieldNumberFormat';
import type { WorkOrderPriceRatioRowData } from 'gql/graphql';
import { TextField } from 'uikit';

import type React from 'react';

interface INoteCellRendererComponent {
    valueNote: Record<string, string>;
    handleChangesValueNote: (rowId: number) => ({ value }: { value: TextFieldPropValue }) => void;
    checkedIds: number[];
    data: WorkOrderPriceRatioRowData;
}
export const NoteCellRenderer: React.FC<INoteCellRendererComponent> = (props) => {
    const { valueNote, handleChangesValueNote, data, checkedIds } = props;

    return (
        <TextField
            value={valueNote[data?.id]}
            onChange={handleChangesValueNote(data?.id)}
            disabled={!checkedIds[data?.id]}
            placeholder=""
            size="s"
        />
    );
};

NoteCellRenderer.displayName = 'NoteCellRenderer';
